// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jR4gh","option":"styles_option__1Rmm8","active":"styles_active__eweXh"};